import { RouteRecordRaw } from 'vue-router'
import ToolboxLayout from '../../components/Toolbox/ToolboxLayout.vue'
import Dashboard from '../../components/Toolbox/Dashboard.vue'
import LoginView from '../../components/Toolbox/LoginView.vue'

const routes: RouteRecordRaw[] = [
    {
        path: '/',
        name: 'toolbox_login',
        component: LoginView,
    },
    {
        path: '/toolbox',
        component: ToolboxLayout,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: 'toolbox_dashboard',
                component: Dashboard,
                meta: { title: 'Tableau de bord' }
            },
            {
                path: 'admin',
                name: 'toolbox_admin',
                component: () => import('../../components/Toolbox/Admin/AdminView.vue'),
                meta: { title: 'Administration', requiredRole: 'ROLE_ADMIN' }
            },
            {
                path: 'copy-paste',
                name: 'tool_copypaste',
                component: () => import('../../components/Toolbox/Tools/CopyPaste/CopyPasteView.vue'),
                meta: { title: 'Copy/Paste', requiredRole: 'ROLE_TOOL_COPYPASTE' }
            },
            {
                path: 'todo',
                name: 'tool_todo',
                component: () => import('../../components/Toolbox/Tools/Todo/TodoView.vue'),
                meta: { title: 'Todo List', requiredRole: 'ROLE_TOOL_TODO' }
            },
            {
                path: 'ai-assistant',
                name: 'tool_ai_assistant',
                component: () => import('../../components/Toolbox/Tools/AiAssistant/AiAssistantView.vue'),
                meta: { title: 'Assistant de réponse IA', requiredRole: 'ROLE_TOOL_AI_ASSISTANT' }
            },
            {
                path: 'simkl-sync',
                name: 'tool_simkl_sync',
                component: () => import('../../components/Toolbox/Tools/SimklSync/SimklSyncView.vue'),
                meta: { title: 'Simkl Sync', requiredRole: 'ROLE_TOOL_SIMKLSYNC' }
            }
        ]
    }
]

export default routes
